import { useState } from "react";
import { Link } from "wouter";
import { FeedbackModal } from "./FeedbackModal";
import { SuggestSpotModal } from "./SuggestSpotModal";
import styles from "./Footer.module.css";

/**
 * Page footer — Figma node 114:5647. Top border-faint divider above a
 * stack of: ghost wordmark + tagline, link list, copyright + provider
 * attribution. "Suggest a spot" and "Feedback" open their respective
 * modals; both POST to /api/feedback and email info@bigwind.surf.
 */
export function Footer() {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [suggestOpen, setSuggestOpen] = useState(false);

  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.text}>
          <div className={styles.brand}>
            <p className={styles.wordmark} aria-hidden>
              BIG WIND
            </p>
            <p className={styles.tagline}>
              Spot forecasts for wind-powered board sports
            </p>
          </div>
          <nav className={styles.links}>
            <button
              type="button"
              className={styles.link}
              onClick={() => setSuggestOpen(true)}
            >
              Suggest a spot
            </button>
            <button
              type="button"
              className={styles.link}
              onClick={() => setFeedbackOpen(true)}
            >
              Feedback
            </button>
            <Link href="/how-it-works" className={styles.link}>
              About
            </Link>
            <a
              href="https://instagram.com/bigwind.sweden"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              Instagram
            </a>
          </nav>
        </div>
        <p className={styles.attribution}>
          ©2026 Big Wind · Forecast data:{" "}
          <a
            href="https://www.smhi.se/en/services/open-data"
            target="_blank"
            rel="noreferrer"
            className={styles.attributionLink}
          >
            SMHI
          </a>
          {" "}and{" "}
          <a
            href="https://open-meteo.com/"
            target="_blank"
            rel="noreferrer"
            className={styles.attributionLink}
          >
            Open-Meteo
          </a>
          {" "}(CC&nbsp;BY&nbsp;4.0)
        </p>
      </footer>
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
      />
      <SuggestSpotModal
        open={suggestOpen}
        onClose={() => setSuggestOpen(false)}
      />
    </>
  );
}
